function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["renderLink", "onPageChange", "activePage", "page", "totalPageCount", "linkText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { KEYCODE_ENTER, NUMBERED_LINK } from "../../utils/index.js";
var PageLink = function PageLink(_ref) {
  var LinkComponent = _ref.renderLink,
    onPageChange = _ref.onPageChange,
    activePage = _ref.activePage,
    page = _ref.page,
    totalPageCount = _ref.totalPageCount,
    _ref$linkText = _ref.linkText,
    linkText = _ref$linkText === void 0 ? page : _ref$linkText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isActivePage = page === activePage;
  var isNextPage = page === activePage + 1;
  var isPreviousPage = page === activePage - 1;
  var data = {
    page: page,
    total: totalPageCount,
    activePage: activePage,
    isPreviousPage: isPreviousPage,
    isNextPage: isNextPage,
    isActivePage: isActivePage
  };
  var pageChangeHandler = function pageChangeHandler(event) {
    onPageChange(data, event);
  };
  var onKeyDownHandler = function onKeyDownHandler(event) {
    if (event.keyCode === KEYCODE_ENTER) {
      pageChangeHandler(event);
    }
  };
  return isActivePage ? /*#__PURE__*/React.createElement("span", {
    "aria-current": "page",
    "aria-label": "Page ".concat(page, ", current page"),
    className: styles.clickableArea
  }, linkText) : /*#__PURE__*/React.createElement(LinkComponent, {
    pageData: data,
    pageLinkProps: _objectSpread(_objectSpread(_objectSpread({
      'aria-label': "Go to page ".concat(page),
      className: styles.clickableArea,
      'data-link-type': NUMBERED_LINK,
      onClick: pageChangeHandler,
      onKeyDown: onKeyDownHandler,
      tabIndex: '0',
      children: linkText
    }, isNextPage ? {
      rel: 'next'
    } : {}), isPreviousPage ? {
      rel: 'prev'
    } : {}), rest)
  });
};
process.env.NODE_ENV !== "production" ? PageLink.propTypes = {
  renderLink: PropTypes.func.isRequired,
  activePage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  totalPageCount: PropTypes.number.isRequired,
  linkText: PropTypes.node,
  onPageChange: PropTypes.func.isRequired
} : void 0;
PageLink.defaultProps = {
  linkText: undefined
};
export default PageLink;